export const center_app_version = {"commit_sha": "8751fc09"}
